import moment from 'moment';
import React, { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { Link, useNavigate } from "react-router-dom";
import CustomTable from '../../../Components/CustomTable/CustomTable';
const ListViewTable = ({ listData, page, setPage, limit, setlimit }) => {

    const navigate = useNavigate();

    const columns = useMemo(
        () => [
            {
                Header: "Order ID",
                disableFilters: true,
                filterable: true,
                CustomDesign: (cellProps) => (
                    <><Link to="#" className="fw-medium link-primary">#{cellProps?.orderUniqueId}</Link></>
                )


            },
            {
                Header: "User",
                disableFilters: true,
                filterable: true,
                CustomDesign: (cellProps) =>
                    cellProps?.User?.firstName ? cellProps?.User?.firstName + " " + cellProps?.User?.lastName : "-",
            },
            {
                Header: "Amount",
                accessor: "totalAmount",
                disableFilters: true,
                filterable: true,
                CustomDesign: (cellProps) =>
                    cellProps?.totalAmount ? cellProps?.totalAmount : "-",
            },
            {
                Header: "Order Items",
                disableFilters: true,
                filterable: true,
                CustomDesign: (cellProps) => cellProps?.Cart?.CartItems?.length,
            },
            {
                Header: "Order Date",
                disableFilters: true,
                filterable: true,
                CustomDesign: (cellProps) => cellProps?.createdAt ? moment(cellProps.createdAt).format('DD-MM-YYYY') : '-',
            },
            {
                Header: "Delivery Date",
                disableFilters: true,
                filterable: true,
                CustomDesign: (cellProps) => cellProps?.deliveryDate ? moment(cellProps.deliveryDate).format('DD-MM-YYYY') : '-',
            },
            {
                Header: "Payment Method",

                disableFilters: true,
                filterable: true,
                CustomDesign: (cellProps) =>
                    cellProps?.Payment?.paymentMethod ? cellProps?.Payment?.paymentMethod : "COD",
            },
            // {
            //     Header: "Status",
            //     disableFilters: true,
            //     filterable: true,
            // CustomDesign: (cellProps) => {
            //     const trackingStatus = cellProps?.OrderActivities[0]?.trackingStatus;

            //     switch (trackingStatus) {
            //         case "Order Process":
            //             return (<span className="badge bg-success-subtle text-success text-uppercase"> {trackingStatus}</span>)
            //         case "Packed":
            //             return (<span className="badge bg-danger-subtle text-danger text-uppercase"> {trackingStatus}</span>)
            //         case "Order Shipped":
            //             return (<span className="badge bg-warning-subtle text-warning text-uppercase"> {trackingStatus}</span>)
            //         case "Order Process":
            //             return (<span className="badge bg-secondary-subtle text-secondary text-uppercase"> {trackingStatus}</span>)
            //         case "Out Of Delivery":
            //             return (<span className="badge bg-primary-subtle text-primary text-uppercase"> {trackingStatus}</span>)
            //         case "Delivered":
            //             return (<span className="badge bg-primary-subtle text-primary text-uppercase"> {trackingStatus}</span>)
            //         case "Cancelled":
            //             return (<span className="badge bg-primary-subtle text-primary text-uppercase"> {trackingStatus}</span>)
            //         case "Pending":
            //             return (<span className="badge bg-primary-subtle text-primary text-uppercase"> {trackingStatus}</span>)
            //         case "Returns":
            //             return (<span className="badge bg-primary-subtle text-primary text-uppercase"> {trackingStatus}</span>)
            //         default:
            //             return (<span className="">-</span>)
            //     }
            // },
            // CustomDesign: (cellProps) => {
            //     console.log('orderActivities', cellProps?.orderActivity)
            //     const orderActivities = cellProps?.orderActivity;
            //     if (!orderActivities || orderActivities.length === 0) {
            //         return <span className="">-</span>;
            //     }
            //     const trackingStatus = orderActivities[0]?.trackingStatus;

            //     switch (trackingStatus) {
            //         case "Order Process":
            //             return (<span className="badge bg-success-subtle text-success text-uppercase"> {trackingStatus}</span>)
            //         case "Packed":
            //             return (<span className="badge bg-danger-subtle text-danger text-uppercase"> {trackingStatus}</span>)
            //         case "Order Shipped":
            //             return (<span className="badge bg-warning-subtle text-warning text-uppercase"> {trackingStatus}</span>)
            //         case "Order Process":
            //             return (<span className="badge bg-secondary-subtle text-secondary text-uppercase"> {trackingStatus}</span>)
            //         case "Out Of Delivery":
            //             return (<span className="badge bg-primary-subtle text-primary text-uppercase"> {trackingStatus}</span>)
            //         case "Delivered":
            //             return (<span className="badge bg-primary-subtle text-primary text-uppercase"> {trackingStatus}</span>)
            //         case "Cancelled":
            //             return (<span className="badge bg-primary-subtle text-primary text-uppercase"> {trackingStatus}</span>)
            //         case "Pending":
            //             return (<span className="badge bg-primary-subtle text-primary text-uppercase"> {trackingStatus}</span>)
            //         case "Returns":
            //             return (<span className="badge bg-primary-subtle text-primary text-uppercase"> {trackingStatus}</span>)
            //         default:
            //             return (<span className="">-</span>);
            //     }
            // },
            // },


            {
                Header: "Action",
                disableFilters: true,
                filterable: true,
                CustomDesign: (cellProps) => {
                    return (
                        <ul className="hstack gap-2 list-unstyled mb-0">
                            <li>
                                <Button className="badge bg-info-subtle text-info" data-bs-toggle="modal" onClick={() => { navigate(`/orders-overview/${cellProps.id}`); }}> View</Button>
                            </li>

                        </ul>
                    )
                },
            },
        ],
        []
    );


    return (
        <React.Fragment>

            <CustomTable limit={limit} setlimit={setlimit} key="Product List" columns={columns} rowsData={listData?.response || []} page={page} setPage={setPage}
                metaData={listData?.additional}
            />
        </React.Fragment>
    );
}

export default ListViewTable;
